import React, { useContext } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LockResetIcon from '@mui/icons-material/LockReset';
import { SnackbarContext } from '../../../providers/SnackBarProvider';
import { AuthContext } from '../../../providers/AuthProvider';
import {
	trackError,
	ERROR_CONTEXTS,
} from '../../../services/analytics.service';
import {
	COLOR_DRAWER_ICON_PASSWORD_RESET,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

export const PasswordReset = (props) => {
	const { callBack } = props;
	const { setSnackbar } = useContext(SnackbarContext);
	const { sendPasswordReset } = useContext(AuthContext);

	const onClick = async () => {
		try {
			await sendPasswordReset();
			callBack();
			setSnackbar({
				text: 'Password reset email sent',
				severity: 'success',
			});
		} catch (err) {
			trackError(ERROR_CONTEXTS.PASSWORD_RESET, err);
			setSnackbar({
				text: 'Error sending password reset email',
				severity: 'error',
			});
		}
	};

	return (
		<ListItem key={'PasswordReset'} disablePadding>
			<ListItemButton
				onClick={() => {
					onClick();
				}}
				sx={{ '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } }}
			>
				<ListItemIcon
					sx={{
						color: COLOR_DRAWER_ICON_PASSWORD_RESET,
						minWidth: '40px',
					}}
				>
					<LockResetIcon />
				</ListItemIcon>
				<ListItemText
					primary={'Reset password'}
					primaryTypographyProps={{
						variant: 'h5',
						sx: { color: COLOR_DRAWER_ITEM_TEXT },
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
};
